const options: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  month: 'long',
  day: 'numeric',
};

export const getCurrentDate = () =>
  new Date().toLocaleDateString(navigator.language, options);
